import { BodyLargeMedium, BodyRegularMedium } from '@src/fonts/typography/Typography';
import styled from 'styled-components';

export const ProductListArea = styled.div`
  grid-area: 'products';

  display: flex;
  flex-direction: column;

  position: relative;
`;

export const ProductListScrollableContent = styled.div`
  height: 100%;
  max-height: 514px;
  overflow-y: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const ProductListHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;

  p {
    ${BodyLargeMedium};
    font-size: 18px;
    line-height: 28px;
    font-weight: 600;
    color: #464646;
  }
`;

export const ProductListFooter = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;

  padding: 1rem;
  border-top: 2px solid #bbbbbb;
  background-color: white;
`;

export const ProductListFooterInfo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  span {
    ${BodyRegularMedium};
    color: #464646;
    font-weight: 600;
  }

  strong {
    ${BodyLargeMedium};
    font-size: 18px;
    line-height: 28px;
    font-weight: 600;
    color: #464646;
  }
`;

export const ProductList = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;

  display: grid;
  gap: 0.5rem;
  grid-template-columns: 1fr;

  @media (min-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 900px) {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
`;
